"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openBlankTab = exports.openTab = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var DEFAULT_PARAMS = {
    toolbar: true,
    location: true,
    directories: false,
    status: false,
    menubar: false,
    scrollbars: true,
    resizable: false,
    copyhistory: false,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
};
function buildParams(params) {
    return (0, lodash_1.map)(params, function (value, key) {
        if (value === true) {
            value = 'yes';
        }
        else if (value === false) {
            value = 'no';
        }
        return "".concat(key, "=").concat(value);
    }).join(',');
}
function openTab(url, overrides, name, onClose) {
    if (overrides === void 0) { overrides = {}; }
    if (name === void 0) { name = '_blank'; }
    var params = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, DEFAULT_PARAMS), overrides);
    var _params = buildParams(params);
    var tab = window.open(url, name, _params);
    if (!tab) {
        return;
    }
    if (onClose) {
        var timer_1 = setInterval(function () {
            if (tab.closed) {
                clearInterval(timer_1);
                onClose();
            }
        }, 300);
    }
    try {
        if (tab.moveTo) {
            tab.moveTo(params.left, params.top);
        }
        tab.focus();
    }
    catch (e) {
        // Access Denied Exception in IE11.
    }
}
exports.openTab = openTab;
function openBlankTab(url) {
    window.open(url, '_blank');
}
exports.openBlankTab = openBlankTab;
//# sourceMappingURL=open-tab.js.map